import { graphql, Link, StaticQuery } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import Img from "gatsby-image"
import HeaderSmall from "./headerSmall"

export const stdStarImage = graphql`
  fragment stdStarImage on File {
    childImageSharp {
      fixed(width: 150, height: 95) {
        ...GatsbyImageSharpFixed
      }
    }
  }
`

const GuideTermsComponent = ({TermCategory,TermText}) => (
  <StaticQuery
    query={graphql`
      query {
        car2019star5: file(relativePath: { eq: "2019-car-defaqto-5.png" }) {
          ...stdStarImage
        },
        car2019star4: file(relativePath: { eq: "2019-car-defaqto-4.png" }) {
          ...stdStarImage
        },
        car2019star3: file(relativePath: { eq: "2019-car-defaqto-3.png" }) {
          ...stdStarImage
        }
      }
    `}
    render={data => (
      <>
        <div className="moto-widget moto-widget-row row-gutter-0 moto-bg-color5_1 moto-spacing-top-zero moto-spacing-right-auto moto-spacing-bottom-zero moto-spacing-left-auto" data-grid-type="xs" data-widget="row" data-spacing="zaza" style={{}} data-bg-position="left top">
          <div className="container-fluid">
            <div className="row" data-container="container">

        <div className="moto-widget moto-widget-row__column moto-cell col-xs-5 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" style={{}} data-widget="row.column" data-container="container" data-spacing="aaaa" data-bg-position="left top">
          <div className="moto-widget moto-widget-row moto-bg-color5_1 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" data-grid-type="sm" data-widget="row" data-spacing="aaaa" style={{}} data-bg-position="left top">
            <div className="container-fluid">
              <div className="row" data-container="container">
                <div className="moto-widget moto-widget-row__column moto-cell col-sm-12 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" style={{}} data-widget="row.column" data-container="container" data-spacing="aaaa" data-bg-position="left top">
                  <div className="moto-widget moto-widget-text moto-preset-default moto-spacing-top-small moto-spacing-right-auto moto-spacing-bottom-small moto-spacing-left-small" data-widget="text" data-preset="default" data-spacing="sass" data-visible-on="mobile-v" data-animation>
                    <div className="moto-widget-text-content moto-widget-text-editable"><p className="moto-text_system_11"><strong><span className="moto-color3_1">{TermCategory}</span></strong></p></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="moto-widget moto-widget-row__column moto-cell col-xs-7 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" style={{}} data-widget="row.column" data-container="container" data-spacing="aaaa" data-bg-position="left top">
          <div className="moto-widget moto-widget-row moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" data-grid-type="xs" data-widget="row" data-spacing="aaaa" style={{backgroundColor: 'transparent'}} data-bg-position="left top">
            <div className="container-fluid">
              <div className="row" data-container="container">
                <div className="moto-widget moto-widget-row__column moto-cell col-xs-12 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" style={{}} data-widget="row.column" data-container="container" data-spacing="aaaa" data-bg-position="left top">
                  <div className="moto-widget moto-widget-row moto-bg-color5_1 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" data-grid-type="xs" data-widget="row" data-spacing="aaaa" style={{}} data-bg-position="left top">
                    <div className="container-fluid">
                      <div className="row" data-container="container">
                        <div className="moto-widget moto-widget-row__column moto-cell col-xs-11 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" style={{}} data-widget="row.column" data-container="container" data-spacing="aaaa" data-bg-position="left top">
                          <div className="moto-widget moto-widget-text moto-preset-default moto-spacing-top-small moto-spacing-right-auto moto-spacing-bottom-small moto-spacing-left-small" data-widget="text" data-preset="default" data-spacing="sass" data-visible-on="mobile-v" data-animation>
                            <div className="moto-widget-text-content moto-widget-text-editable"><p className="moto-text_system_11"><span className="moto-color3_1">{TermText}</span></p></div>
                          </div>
                        </div>
                        <div className="moto-widget moto-widget-row__column moto-cell col-xs-1 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" style={{}} data-widget="row.column" data-container="container" data-spacing="aaaa" data-bg-position="left top">
                          <div className="moto-widget moto-widget-text moto-preset-default moto-spacing-top-small moto-spacing-right-small moto-spacing-bottom-auto moto-spacing-left-auto" data-widget="text" data-preset="default" data-spacing="ssaa" data-visible-on="mobile-v" data-animation data-draggable-disabled>
                            <div className="moto-widget-text-content moto-widget-text-editable"><p className="moto-text_system_11" style={{textAlign: 'center'}}><strong><span className="moto-color1_1">✓</span></strong></p></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

            </div>
          </div>
        </div>

        <div className="moto-widget moto-widget-row moto-spacing-top-small moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" data-grid-type="sm" data-widget="row" data-spacing="saaa" style={{}} data-bg-position="left top">
          <div className="container-fluid">
            <div className="row" data-container="container">
              <div className="moto-widget moto-widget-row__column moto-cell col-sm-12 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" style={{}} data-widget="row.column" data-container="container" data-spacing="aaaa" data-bg-position="left top">
              </div>
            </div>
          </div>
        </div>
      </>
    )}
    />
)

export default GuideTermsComponent